<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-sheet v-if="currentDraft.questions[questionId]" :color-theme="themeColor">
    <f7-toolbar color-theme="white" style="font-size: 16px;">
      <f7-link style="color: #7E7E7E">{{ question.title }}預設值</f7-link>
    </f7-toolbar>
    <f7-page-content>
      <f7-list class="list-prop-reset" media-list>
        <f7-list-item
          checkbox
          title="常駐顯示"
          :checked="question.alwaysDisplay"
          @change="updateAlwaysProperties('alwaysDisplay', $event.target.checked)"/>
        <f7-list-item v-for="(option, index) in options" style="border-bottom: 0px;" :title="option.title" :key="`question-default-value-actions-${index}`" @click="updateDefault(option)"></f7-list-item>
        <f7-list-item class="color-danger font-weight-bold" @click="reset()">
          <div>
            <font-awesome-icon icon="trash" />
            移除預設值
          </div>
        </f7-list-item>
        <f7-list-item class="color-danger font-weight-bold" @click="closeSheet()">
          取消
        </f7-list-item>
      </f7-list>
    </f7-page-content>
  </f7-sheet>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as R from 'ramda'

export default {
  dependencies: ['themeColor'],
  name: 'QuestionDefaultValueActions',
  data () {
    return {
      pathLength: 0
    }
  },
  created () {
    this.pathLength = this.currentElementPath.length
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String,
    questionIdProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft', 'currentElementPath']),
    elementLevel () { return this.pathLength > 5 ? 5 : 3 },
    question () { return this.currentDraft.questions[this.questionId] },
    options () { return this.question.options.map(oid => this.currentDraft.options[oid]) },
    questionId () { return this.currentElementPath[this.elementLevel] ? this.currentElementPath[this.elementLevel].id : null }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setQuestionProperties']),
    updateDefault (option) {
      const defaultValue = option instanceof Object ? option.id : null
      this.setQuestionProperties({ questionId: this.question.id, elementLevel: this.elementLevel, properties: { defaultValue } })
      this.closeSheet()
    },
    updateAlwaysProperties (prop, v) {
      this.setQuestionProperties({ questionId: this.question.id, elementLevel: this.elementLevel, properties: R.assoc(prop, v, {}) })
    },
    closeSheet () {
      this.$f7.sheet.close()
    },
    reset () { // 移除預設值
      this.updateDefault()
      this.updateAlwaysProperties('alwaysDisplay', false)
    }
  }
}
</script>

<style scoped>
  .color-danger {
    color: #F44437;
  }

  .font-weight-bold {
    font-weight: 500;
  }

  .list-prop-reset {
    margin: 0;
  }
</style>
